var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-layout',{staticClass:"auth-layout",attrs:{"view":"hHh lpR fFf"}},[_c('q-page-container',[_c('div',{staticClass:"auth-center"},[_c('q-img',{staticClass:"q-mb-lg logo-shadow",staticStyle:{"width":"110px","height":"110px"},attrs:{"src":"@/assets/logo.png","alt":"Мегасофт Плус","spinner-color":"mint"}}),_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }